const user_scopes = {
    descriptions: {
        custom_data: 'Tvé osobní údaje',
        email: 'Tvá e-mailová adresa',
        phone: 'Tvé telefonní číslo',
        profile: 'Tvé jméno, uživatelské jméno, profilový obrázek a další údaje o profilu',
        roles: 'Tvé role',
        identities: 'Tvé propojené sociální účty',
        'urn:logto:scope:organizations': 'Informace o tvé organizaci',
        'urn:logto:scope:organization_roles': 'Role v tvé organizaci',
        address: 'Tvá adresa',
        'urn:logto:scope:sessions': 'Tvé aktivní relace',
    },
};
export default Object.freeze(user_scopes);
